__webpack_require__.p = "/mgm/";